import { cservWorkflowStatus } from '../../../dtos.js';
import { content as terminContent } from '../../../utils';

export const content = {
  ...terminContent,
  draggableId: 'planungsstatus',
  heading: 'Planungsstatus',
  fields: {
    planungszeitraum: 'Planungszeitraum',
    workflowStatus: 'Workflow-Status',
    agilePlanerin: 'Agile:r Planer:in',
    termineImPlanungsintervall1: 'Termine im Planungsintervall',
    termineImPlanungsintervall2: '(ist/soll)',
  },
  workflowStatusLabels: {
    [cservWorkflowStatus.Produktmanagement]: 'Produktmanagement',
    [cservWorkflowStatus.VA_ORGA]: 'VA-Orga',
    [cservWorkflowStatus.PLANUNG_ABGESCHLOSSEN]: 'Planung abgeschlossen',
    [cservWorkflowStatus.PLANUNG_INAKTIV]: 'Planung inaktiv',
    unknown: terminContent.noInfoAvailable,
  },
  workflowStatusTooltips: {
    [cservWorkflowStatus.Produktmanagement]: `Die Planungsinformationen liegen aktuell beim Produkt-Manager zur Bearbeitung.
    Sobald der Produkt-Manager den Status auf 161 = VA-Orga setzt, werden die neuen Planungsinformationen in Viva übernommen.`,
    [cservWorkflowStatus.VA_ORGA]:
      'Die Planungsinformationen wurden vom Produkt-Manager für die Planung von Veranstaltungen für die aktuelle Planungsphase freigegeben.',
    [cservWorkflowStatus.PLANUNG_ABGESCHLOSSEN]:
      'Die Planung für die aktuelle Planungsphase wurde in ContentServ abgeschlossen.',
    [cservWorkflowStatus.PLANUNG_INAKTIV]: 'Die Planung wurde vom Produkt-Manager auf inaktiv gesetzt.',
    inBearbeitung: `Die Planungsinformationen liegen aktuell beim Produkt-Manager zur Bearbeitung.
    Sobald das Produkt den Bearbeitungsstatus verlässt, werden die neuen Planungsinformationen in Viva übernommen.`,
    unknown: '',
  },
} as const;
